import { ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { LookupGetService } from '../../service/lookup-service/lookup-get.service';
import { ModalContentComponent } from '../modal-content/modal-content.component';
import { MeddraLevel } from '../../ui/MeddraEnum';
import { Clipboard } from '@angular/cdk/clipboard';
import { environment } from '../../../../environments/environment';
import { Art57Section } from '../../ui/Art57Section/Art57Section';


@Component({

  selector: 'app-modal-wrapper',
  styleUrls: ['./modal-wrapper.component.css'],
  templateUrl: './modal-wrapper.component.html',
})

export class ModalWrapperComponent extends FieldWrapper implements OnInit {

  modalRef!: BsModalRef;
  text!: string;
  private isModalOpen = false;

  //Constructor
  constructor(private modalService: BsModalService,
    private cdRef: ChangeDetectorRef,
    private injector: Injector,
    private clipboard: Clipboard) {
    super();
  }

  //Open the modal window when TAB key is not pressed
  onKeyUp(event: KeyboardEvent): void {
    if (event.key == 'Delete') {
      this.text = "";
      this.formControl.setValue(undefined);
      this.formControl.parent?.get("resolutionmode")?.setValue(undefined);
      this.formControl.parent?.get("name")?.setValue(undefined);
    } else if (event.key !== 'Tab' && event.key !== 'Shift') {
      this.openModal();
    }
  }

  onCopyClipboard() {
    this.clipboard.copy(this.formControl.value);
    this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: `${this.formControl.value} copied to clipboard`, life: environment.warningElapsedTime });
  }

  //Init control
  ngOnInit(): void {

    let nameFormControl = this.formControl.parent?.get("name");
    if (nameFormControl) {
      nameFormControl.valueChanges.subscribe(value => {
        this.text = value;
      });
    }

    //Load the lookupname if the lookup has currently the code value
    if (this.formControl.getRawValue() === 0 || this.formControl.getRawValue()) {

      //Local 
      if (this.formControl.parent?.get("resolutionmode")?.getRawValue() === 1) {
        //Retrieve the local name
        //Retrieve the remote name from lookup service if empty
        if (this.formControl.parent?.get("name")?.getRawValue()) {
          this.text = this.formControl.parent?.get("name")?.getRawValue();
          this.cdRef.detectChanges();
        }

        //Remote  
      } else {

        //Retrieve the remote name from lookup service if empty
        if (!this.formControl.parent?.get("name")?.getRawValue()) {

          //Pre-processing
          let code: string = this.formControl.getRawValue();
          switch (this.field.props?.["lookup"].name) {
            case "substance":
              code = this.formControl.getRawValue() + "_1";
              break;
            case 'SOC':
            case 'HLGT':
            case 'HLT':
            case 'PT':
            case 'LLT':
              if ((this.formControl.parent) && (this.formControl.parent!.parent!.get("meddraversion") != null)) {
                code = this.formControl.getRawValue() + "_v" + this.formControl.parent!.parent!.get("meddraversion")!.value;
              }
              break;
          }


            this.injector.get(LookupGetService).get(this.field.props?.["lookup"].name, code)
              .subscribe({
                next: data => {

                  //Post-processing
                  let label: string = data && data.name ? data.name : '';
                  switch (this.field.props?.["lookup"].name) {
                    case "qppv":
                      label = data && data.name && data.organisationID ? data.name + " (" + data.organisationID + ")" : '';
                      break;
                    case "mfl":
                      label = data && data.countrycode && data.city ? data.countrycode + " - " + data.city : '';
                      break;
                  }

                  this.text = label;
                  this.formControl.parent?.get("name")?.setValue(label);
                  this.cdRef.detectChanges();
                }

              });


        } else {
          this.text = this.formControl.parent?.get("name")?.getRawValue();
          this.cdRef.detectChanges();
        }
      }

    }

    if (this.field.props!["required"] && !this.field.props!["label"]?.toString().endsWith("*")) {
      this.field.props!["label"] = this.field.props!["label"]!.concat(" *");
    }

  }

  //Open modal window
  openModal() {

    let value = this.formControl.getRawValue() != null ?
      this.formControl.getRawValue().toString() : '';

    if (this.isModalOpen) return;
    this.isModalOpen = true; // Set flag to true

    //Retrieve the lookup metadata object
    const lookup: any = this.field.props?.["lookup"];

    //Show modal dialog
    this.modalRef = this.modalService.show(ModalContentComponent,
      {
        initialState: {
          message: { lookup: lookup, selectedValue: value }
        }
      }
    );

    //Close modal suscription 
    this.modalRef.onHidden!.subscribe(() => {
      this.isModalOpen = false;
      if (this.modalRef.content.selectedName) {
        if (this.modalRef.content.selectedName === "blank") {
          this.text = "";
          this.formControl.setValue(undefined);
          this.formControl.parent?.get("resolutionmode")?.setValue(undefined);
          this.formControl.parent?.get("name")?.setValue(undefined);
        } else {
          this.text = this.modalRef.content.selectedName;
          this.formControl.setValue(this.modalRef.content.selectedCode);
          this.formControl.parent?.get("resolutionmode")?.setValue(this.modalRef.content.resolutionMode);
          this.formControl.parent?.get("name")?.setValue(this.modalRef.content.selectedCode != 'blank' ? this.modalRef.content.selectedName : undefined);
        }
        this.cdRef.detectChanges();
      }
    });




  }

}
